import MuiToggleButtonGroup, {
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup/ToggleButtonGroup';
import { OverridableStringUnion } from '@mui/types';
import { ToggleButtonGroupPropsColorOverrides } from '@mui/material/ToggleButtonGroup';
import { forwardRef } from 'react';

declare module '@mui/material/ToggleButtonGroup' {
  interface ToggleButtonGroupPropsColorOverrides {
    default: true;
    internal: true;
  }
}

export interface ToggleButtonGroupProps extends MuiToggleButtonGroupProps {
  color?: OverridableStringUnion<
    'default' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error' | 'internal',
    ToggleButtonGroupPropsColorOverrides
  >;
}

const ToggleButtonGroup = forwardRef<HTMLButtonElement, ToggleButtonGroupProps>((props, ref) => {
  return <MuiToggleButtonGroup ref={ref} {...props} />;
});

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

export default ToggleButtonGroup;
